export default {
  home: {
    hero: {
      title: 'Sicherheitskamera & Alarmanlage für Privat und Gewerbe',
      subtitle: 'SSG Signaltechnik plant, installiert und betreut moderne Videoüberwachung und Alarmanlagen im gesamten Rhein-Main-Gebiet – von Hainburg über Offenbach, Frankfurt und Hanau bis Darmstadt und Groß-Gerau. Individuell abgestimmt auf Ihr Objekt, Ihre Anforderungen und die Bereiche, die wirklich geschützt werden sollen.',
      ctaPrimary: 'Kostenlose Erstberatung anfragen',
      ctaSecondary: 'KameraPlaner starten',
    },
    trust: {
      '0': 'Individuelle Planung',
      '1': 'Fachgerechte Installation',
      '2': 'App-Einrichtung',
      '3': 'Persönliche Betreuung',
      '4': 'Privat und Gewerbe',
    },
    service: {
      eyebrow: 'Unser Ansatz',
      title: 'Mehr als nur Kameras montieren',
      lead: 'Jedes Objekt ist anders. Deshalb schauen wir uns Ihre Situation genau an, bevor wir eine einzige Kamera vorschlagen. Der vollständige Service umfasst:',
      steps: {
        '0': 'Bedarf und Objekt analysieren',
        '1': 'Kameratyp und Blickwinkel auswählen',
        '2': 'Mögliche tote Winkel prüfen',
        '3': 'Verkabelung, Netzwerk und Aufzeichnung planen',
        '4': 'Fachgerecht montieren und ausrichten',
        '5': 'Smartphone-App und Fernzugriff einrichten',
        '6': 'Kunden verständlich einweisen',
        '7': 'Anlage auf Wunsch laufend betreuen',
      },
      more: 'Alle Leistungen entdecken',
    },
    solutions: {
      eyebrow: 'Objekttypen',
      title: 'Lösungen für jedes Objekt',
      lead: 'Ob Eigenheim, Ladengeschäft oder Produktionshalle – wir finden die passende Lösung für Ihre Anforderungen.',
      filter: { alle: 'Alle', privat: 'Privat', gewerbe: 'Gewerbe', innen: 'Innen', aussen: 'Außen', neu: 'Neuanlage' },
      more: 'Mehr erfahren',
      viewAll: 'Alle Lösungen ansehen',
    },
    area: {
      eyebrow: 'Einsatzgebiet',
      title: 'Sicherheitskameras & Alarmanlagen im gesamten Rhein-Main-Gebiet',
      lead: 'Von unserem Standort in Hainburg sind wir im ganzen Ballungsraum unterwegs: Frankfurt, Offenbach, Hanau, Darmstadt, Groß-Gerau und alle umliegenden Gemeinden. Planung, Montage und Betreuung Ihrer Sicherheitskamera oder Alarmanlage – immer persönlich und vor Ort.',
      viewAll: 'Alle Einsatzgebiete ansehen',
    },
    tech: {
      eyebrow: 'Technische Planung',
      title: 'Die passende Technik für das richtige Ziel',
      lead: 'Nicht nur die Megapixelzahl zählt. Eine gute Kameraanlage entsteht durch das Zusammenspiel vieler Faktoren.',
      points: {
        '0': { title: 'Innen- oder Außenbereich', desc: 'Feuchtraum, Witterung und Temperatur bestimmen die Kameraauswahl.' },
        '1': { title: 'Licht und Nachtbedingungen', desc: 'Tag-/Nacht- und Low-Light-Lösungen für jede Beleuchtungssituation.' },
        '2': { title: 'Übersicht oder Detailerkennung', desc: 'Weitwinkel für den Gesamtblick oder Tele für Gesichter und Kennzeichen.' },
        '3': { title: 'Entfernung und Montagehöhe', desc: 'Je höher und weiter, desto mehr Auflösung und besseres Objektiv nötig.' },
        '4': { title: 'Blickwinkel und Objektiv', desc: 'Festbrennweite, varifokal oder motorisiert – passend zum Einsatzzweck.' },
        '5': { title: 'Aufzeichnung und Speicher', desc: 'Lokaler Rekorder mit festplattenbasierter Speicherung nach Bedarf.' },
        '6': { title: 'App-Zugriff', desc: 'Live-Ansicht und Wiedergabe per Smartphone, je nach System und Konfiguration.' },
        '7': { title: 'Ereignisbenachrichtigungen', desc: 'Push-Meldungen bei Bewegung oder definierbaren Ereignissen, je nach System.' },
        '8': { title: 'Erweiterbarkeit', desc: 'Vorhandene Anlagen lassen sich in der Regel um weitere Kameras ergänzen.' },
      },
    },
    process: {
      eyebrow: 'Ablauf',
      title: 'So läuft Ihr Projekt ab',
      lead: 'Von der ersten Anfrage bis zur fertigen Anlage – transparent und persönlich.',
      steps: {
        '0': { title: 'Erstgespräch', desc: 'Wir besprechen Ihren Bedarf, Ihr Objekt und die Bereiche, die Sie überwachen möchten.' },
        '1': { title: 'Besichtigung und Planung', desc: 'Vor-Ort-Termin zur Analyse von Licht, Blickwinkeln, Montagepunkten und Verkabelung.' },
        '2': { title: 'Individuelles Angebot', desc: 'Sie erhalten ein transparentes Angebot mit passender Technik und klarem Leistungsumfang.' },
        '3': { title: 'Installation und Einrichtung', desc: 'Fachgerechte Montage, Netzwerk-Anbindung, Rekorder-Einrichtung und App-Konfiguration.' },
        '4': { title: 'Einweisung und Betreuung', desc: 'Sie lernen die Bedienung kennen. Bei Fragen sind wir für Sie da – auch danach.' },
      },
    },
    refs: {
      eyebrow: 'Referenzobjekte',
      title: 'Realisierte Projekte',
      lead: 'Ein Auszug aus unserem Portfolio – von der Privatimmobilie bis zur Gewerbeanlage.',
      viewAll: 'Alle Lösungen entdecken',
      items: {
        '0': { label: 'Privathaus – Einfamilienwohnung', desc: 'Komplettanlage mit 6 Kameras, NVR und App-Anbindung' },
        '1': { label: 'Einzelhandel – Boutique', desc: 'Ladenfläche und Lager mit 4 Kameras und Nachtsicht' },
        '2': { label: 'Logistik – Lagerhalle', desc: 'Großflächenüberwachung mit Weitwinkel und PTZ' },
        '3': { label: 'Praxis – Arztempfang', desc: 'Diskrete Innenüberwachung mit Datenschutz-Maskierung' },
        '4': { label: 'Immobilie – Mehrfamilienhaus', desc: 'Eingang und Außenanlagen mit Hinweisschildern' },
      },
    },
    care: {
      eyebrow: 'Wartung & Betreuung',
      title: 'SSG Care',
      lead: 'Ihre Kameratechnik soll dauerhaft zuverlässig arbeiten. Mit SSG Care erhalten Sie ein flexibles Betreuungsabonnement – monatlich kündbar oder mit vereinbarter Laufzeit.',
      list: {
        '0': 'Regelmäßige Systemprüfung und Firmware-Updates',
        '1': 'Unterstützung bei App- und Zugriffsproblemen',
        '2': 'Hilfe bei Smartphone-Wechsel',
        '3': 'Prüfung von Aufzeichnung und Speicher',
        '4': 'Priorisierte Bearbeitung nach Vereinbarung',
      },
      cta: 'SSG Care entdecken',
    },
    planner: {
      eyebrow: 'Interaktives Tool',
      title: 'Der SSG KameraPlaner',
      lead: 'Zeichnen Sie Räume oder Flächen ein, markieren Sie wichtige Überwachungsbereiche und testen Sie mögliche Kamerapositionen mit Sichtkegeln. Das Ergebnis ist eine unverbindliche Vorplanung für Ihr Gespräch mit uns.',
      list: {
        '0': 'Räume und Wände einzeichnen',
        '1': 'Kamera-Symbole per Drag-and-drop platzieren',
        '2': 'Drehbare Sichtkegel mit Abdeckungsbewertung',
        '3': 'Überwachungsbereiche und Privatzonen markieren',
        '4': 'Ergebnis als Anfrage senden oder drucken',
      },
      cta: 'KameraPlaner starten',
    },
    faq: {
      eyebrow: 'Häufige Fragen',
      title: 'Was Kunden uns oft fragen',
      viewAll: 'Alle Fragen ansehen',
      items: {
        '0': { question: 'Wie viele Kameras benötige ich?', answer: 'Das hängt von der Größe Ihres Objekts, den zu überwachenden Bereichen und dem gewünschten Detailgrad ab. Nach einem Erstgespräch und einer Besichtigung erstellen wir Ihnen einen individuellen Vorschlag.' },
        '1': { question: 'Kann ich die Kameras auf dem Smartphone ansehen?', answer: 'Ja, bei den meisten modernen Systemen ist ein Zugriff per Smartphone-App möglich. Wir richten die App-Verbindung bei der Installation direkt für Sie ein.' },
        '2': { question: 'Funktionieren Kameras bei Dunkelheit?', answer: 'Ja, für Außenbereiche und schlecht beleuchtete Innenräume gibt es spezielle Tag-/Nacht- und Low-Light-Kameras mit Infrarot- oder Farbnachtsicht.' },
        '3': { question: 'Was kostet eine Kameraanlage?', answer: 'Die Kosten hängen von der Anzahl der Kameras, dem Objekt, der Verkabelung und dem gewünschten Funktionsumfang ab. Wir erstellen Ihnen gerne ein individuelles, unverbindliches Angebot.' },
      },
    },
    cta: {
      title: 'Lassen Sie uns gemeinsam herausfinden, welche Lösung zu Ihrem Objekt passt.',
      lead: 'Rufen Sie uns an, schreiben Sie uns – oder starten Sie direkt mit dem KameraPlaner. Wir melden uns zeitnah bei Ihnen.',
      primary: 'Kostenlose Erstberatung anfragen',
      secondary: 'KameraPlaner starten',
    },
  },
  company: {
    solutions: {
      home: { title: 'Zuhause und Grundstück', description: 'Von der Haustür bis zur Garage – diskrete Überwachung für Ihr Eigenheim.' },
      retail: { title: 'Einzelhandel und Gastronomie', description: 'Kassenbereich, Eingang und Lager – professionell abgesichert.' },
      office: { title: 'Büro und Praxis', description: 'Empfang, Flure und sensible Bereiche – datenschutzbewusst geplant.' },
      warehouse: { title: 'Lager und Logistik', description: 'Großflächige Überwachung mit Weitwinkel und Nachtsicht.' },
      workshop: { title: 'Werkstatt und Gewerbe', description: 'Robuste Kameras für rauere Umgebungen – Werkhallen und Außenbereiche.' },
      apartment: { title: 'Mehrfamilienhäuser und Immobilien', description: 'Eingänge, Treppenhäuser und Außenanlagen – für Mieter und Eigentümer.' },
    },
  },
};